import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Zendesk.css";

class Zendesk extends Component {
  static contextTypes = {
    me: PropTypes.object
  };

  injectPlugin = () => {
    if (!this.injected) {
      const loadScript = document.createElement("script");
      const configScript = document.createElement("script");
      configScript.innerHTML = `window.zESettings = {
        webWidget: {
          position: { horizontal: 'right', vertical: 'top' },
          offset: { horizontal: '10px', vertical: '0' }
        }
      };`;
      loadScript.id = "ze-snippet";
      loadScript.src =
        "https://static.zdassets.com/ekr/snippet.js?key=980b53ae-9d63-4615-baaa-d42c9857fd6d";
      document.head.appendChild(configScript);
      document.head.appendChild(loadScript);
      this.injected = true;
    }
  };

  componentWillReceiveProps(nextProps) {
    this.injectPlugin();
  }

  componentDidUpdate() {
    this.injectPlugin();
  }

  render() {
    return <div />;
  }
}

export default Zendesk;
